import { useContext } from 'react';
import { BreakpointsContext } from './BreakpointsContext';
/**
 * Access breakpoints computed by `ReactBreakpoints`
 *
 * Needs provider for `BreakpointsProps`
 * @returns The breakpoint props
 */
export function useBreakpoints() {
    return useContext(BreakpointsContext);
}
//# sourceMappingURL=useBreakpoints.js.map